import { useState, useEffect, useCallback } from 'react';

/**
 * Спільний стан шапки сторінок «Торгівля» (/trading · /trading/dam · /trading/idm) — РЕДИЗАЙН.
 *
 * Операційні елементи (глибина історії 7/14/30/60 діб · доба погодинного профілю)
 * винесені в топбар за стандартом §6 дизайн-контракту, а тіло сторінки їх лише
 * читає. Прийом той самий, що useMarketPricesUi / useForecastUi: модульне
 * значення + подія синхронізації в межах вкладки (без контексту, щоб топбар і
 * тіло не залежали одне від одного деревом компонентів).
 */
const EV = 'helios:trading-ui-change';

export type TradingDays = 7 | 14 | 30 | 60;

const todayIso = () => new Date().toISOString().slice(0, 10);

const state = {
  days: 30 as TradingDays,
  hourlyDate: todayIso() as string,
};

const emit = () => window.dispatchEvent(new CustomEvent(EV));

export function useTradingUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);

  const setDays = useCallback((d: TradingDays) => {
    if (state.days !== d) { state.days = d; emit(); }
  }, []);
  const setHourlyDate = useCallback((d: string) => {
    if (d && state.hourlyDate !== d) { state.hourlyDate = d; emit(); }
  }, []);

  return { days: state.days, hourlyDate: state.hourlyDate, setDays, setHourlyDate };
}

export const tradingTodayIso = todayIso;
